const product = () => {
  $(document).ready(function () {
    if ($('body').hasClass('product')) {
      $('.related-products .wrapper').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
      })

      $('.product-images-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      })

      $('.marquee').marquee()
    }
  })
}

export default product
